const STEPS = ['Your Profile', 'Add a Child', 'Invite Others', 'Set a Goal']

interface Props {
  currentStep: number
  completedSteps: Set<number>
}

export default function OnboardingProgress({ currentStep, completedSteps }: Props) {
  return (
    <div className="w-full max-w-md mx-auto mb-8">
      <div className="flex items-center justify-between">
        {STEPS.map((label, i) => {
          const step = i + 1
          const isCompleted = completedSteps.has(step)
          const isCurrent = step === currentStep

          return (
            <div key={step} className="flex flex-col items-center flex-1">
              <div className="flex items-center w-full">
                {i > 0 && (
                  <div className={`h-0.5 flex-1 transition-colors duration-300 ${
                    completedSteps.has(step) || completedSteps.has(step - 1) ? 'bg-primary' : 'bg-border'
                  }`} />
                )}
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 ${
                  isCompleted
                    ? 'bg-primary text-primary-foreground scale-100'
                    : isCurrent
                      ? 'bg-primary text-primary-foreground scale-110 ring-4 ring-primary/20'
                      : 'bg-muted text-muted-foreground'
                }`}>
                  {isCompleted ? '✓' : step}
                </div>
                {i < STEPS.length - 1 && (
                  <div className={`h-0.5 flex-1 transition-colors duration-300 ${
                    isCompleted ? 'bg-primary' : 'bg-border'
                  }`} />
                )}
              </div>
              <span className={`text-xs mt-1.5 text-center transition-colors ${
                isCurrent ? 'text-primary font-semibold' : 'text-muted-foreground'
              }`}>{label}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
